var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.18 126.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #54bf9f;\n      }\n\n      .cls-2 {\n        fill: #407ec1;\n      }\n\n      .cls-3 {\n        fill: #90bfe7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.17,72.28c.19,24.47-3.6,30.04-6.59,34.64-14.88,22.9-41.05,18.89-41.07,18.9,0,0,.04-.03.02-.02-.02.02-35.99-3.64-39.52-42.98C-1.3,19.95,56.96,29.87,56.96,29.87l.19,21.33c-3.67-.47-13.56-.38-16.85.75-1.17.4-10.53,2.96-14.75,11.39-.41.82-1.45,3.95-1.69,5.13-1.27,6.13-2.92,21.95,6.39,29.89,6.02,5.14,13.48,4.77,14.83,4.69.87-.05,10.53-1.05,16.59-9.03.72-.95,3.29-4.61,3.47-11.68l.29-9.97,21.74-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.43 0 49.06 21.46 65.43 21.46 65.43 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "65.29 63.72 87.03 63.62 87.03 0 65.39 0 65.29 63.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a962d495376d8a11514c43334b0093e3.svg";
export { ForwardRef as ReactComponent };